module.exports = __webpack_public_path__ + "img/winerackdog39.3233e64b.jpg";